jQuery(window).load(function(){
  
  
  $('.flexslider').flexslider({
    animation: "slide",
    slideshow: true,
    animationDuration: 700,
    slideshowSpeed: 4000,
    animation: "fade",
    controlsContainer: ".flex-controls",
    controlNav: false,
    keyboardNav: true
  }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});
  
  
  $("select.loc_on_change").change(function(){
    if($(this).find(":selected").attr("value") == "#") return false;
    window.location = $(this).find(":selected").attr("value");
  });
    
  
});

jQuery(document).ready(function($){
    

  // force wide nav -->  
  
  // <-- end force wide nav
  
  $(".flyout").hide();

  $("#menu-button").on("click", function() {
    $(".flyout").slideToggle( "fast" );
  });

  $(".sub-menu").hide();
  $(".more, .account-links").on("click", function() {
    $(this).nextAll("ul").slideToggle( "fast" );
    $("i", this).toggleClass("fa-plus fa-minus");
    $(this).next(".more").find("i").toggleClass("fa-user fa-minus");
  });
     





  $("a.zoom").click(function(event) {
    event.preventDefault();
    
    var clickedVariantId = $( event.currentTarget ).attr( 'data-variant-id' );
    
    if ( clickedVariantId ) {
       $('#product .thumbs [data-variant-id*="'+ clickedVariantId +'"] a').trigger('click');
       return false;
    } else {
       $('#product .thumbs a').eq(0).trigger('click');
       return false;
    }
   
    
  });

  $('#product .thumbs a').fancybox({
    padding:0,
    'titleShow': false,
    overlayColor: '#000000',
    overlayOpacity: 0.2,
    nextEffect: 'fade',
    prevEffect: 'fade',
    arrows: true,
    nextClick: true
  });

  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });


  
  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })
  
  $('li.dropdown').hover(function(){
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });

  function smoothScrollVertically( hash ) {
    var target = $( hash );
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
      // var top_offset = 0;
      // if ( $('.site-header').css('position') == 'fixed' ) {
      //   top_offset = $('.site-header').height();
      // }
      // if( $('body').hasClass('admin-bar') ) {
      //   top_offset = top_offset + $('#wpadminbar').height();
      // }
       $('html,body').animate({
         scrollTop: target.offset().top
      }, 1200);
      //window.scrollTo(target.offset().top);
      return false;
    }
  }

  // -- Smooth scroll on click
  $('a[href*="#"]:not([href="#"]):not(.no-scroll)').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {
      smoothScrollVertically( this.hash );
    }
  });


  // snow fall animation in header callout (e.g. Black Friday Aktion)
  
  var snow_intensity = 50; // smaller number = more snowflakes;

  function Snowflake(){
    var snowflake = this;
    snowflake.x = (Math.random() * $(document).width());
    snowflake.size = (Math.random() * 35) + 10;
    snowflake.opacity = Math.random();
    snowflake.body = $("<em class='gn-snowflake'>*</em>");
    snowflake.body.css({'font-size': this.size + 'px', 'left': this.x +'px', opacity: this.opacity });
    snowflake.fall = function(){
      var that = this;
      var $snowflake = this.body;
      var swing_direction = 1;
      var swing_wave = Math.random() * 100;
      var interval = setInterval(function(){
        $snowflake.css({left: that.x + (swing_direction * swing_wave)});
        swing_direction = - swing_direction;
      }, 1000);
      var speed = (Math.random() * 10000) + 10000;
      $snowflake.animate({top: '100vh'}, speed, function(){
        clearInterval(interval);
        $snowflake.remove();
      });    
    }
    $('.gn-header__callout-message a').append(snowflake.body);
    snowflake.fall();
  }
  
  var snow = window.setInterval(function () {
     new Snowflake();
  }, snow_intensity);
  
  
});